import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import FlexRow from '../../../../components/molecules/FlexRow'

function ExplainabilityToolbar ({ events }) {
  const handleCopyClick = useCallback((e) => {
    e.stopPropagation()
    e.preventDefault()

    navigator.clipboard.writeText(JSON.stringify(events || [], null, 2)).catch(console.error)
  }, [events])

  return (
    <FlexRow className='justify-end'>
      <span className='clickable font-size-xs' onClick={handleCopyClick}>Copy</span>
    </FlexRow>
  )
}

ExplainabilityToolbar.propTypes = {
  events: PropTypes.array
}

export default ExplainabilityToolbar
